const e = {
  id: "Cash5",
  name: "Jersey Cash 5",
  style: {
    bullseye: {
      bg: "#c93c34",
      color: "#ffffff"
    },
    colorPrimary: "#953d96"
  }
};
export {
  e as default
};
